// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"tips"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M22 3L22 18L15 18L12 21L9 18L2 18L2 3L22 3Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M22 3L22 18L15 18L12 21L9 18L2 18L2 3L22 3Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const TipsIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'tips',
    ref,
    icon: element,
  },
));

TipsIcon.displayName = 'TipsIcon';

export default TipsIcon;
